import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { ICriteria } from '../../../protection.types'
import { PropsWithChildren } from 'react'

interface IProps {
  criteria: Omit<ICriteria, 'id'>
  onChange: (val: any, name: string) => void
}

const CriteriaTemplate = (props: PropsWithChildren<IProps>) => {
  const handleChange = (value: any, name?: string) => {
    const fieldName = name || 'title'
    props.onChange(value, fieldName)
  }

  return (
    <Sheet>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        <TextField header='Название критерия'>
          <TextInput
            value={props.criteria.name}
            onChange={(value) => handleChange(value, 'name')}
            name='name'
            placeholder='Критерий 1'
          />
        </TextField>

        <TextField header='Описание'>
          <>
            <TextInput
              value={props.criteria.description || ''}
              onChange={(value) => {
                if (value.length <= 100) {
                  handleChange(value, 'description')
                }
              }}
              name='description'
              placeholder='Описание критерия'
              maxLength={100}
            />

            <div
              style={{
                marginTop: '4px',
                fontSize: '12px',
                textAlign: 'right',
                color: (props.criteria.description?.length || 0) >= 100 ? 'red' : '#666',
              }}
            >
              {props.criteria.description?.length || 0}/100
            </div>
          </>
        </TextField>
        <TextField header='Мин. значение'>
          <TextInput
            type='number'
            value={props.criteria.minValue?.toString() || '0'}
            onChange={(value) => handleChange(Number(value), 'minValue')}
            name='minValue'
            placeholder='0'
            maxLength={100}
          />
        </TextField>

        <TextField header='Макс. значение'>
          <TextInput
            type='number'
            value={props.criteria.maxValue?.toString() || '10'}
            onChange={(value) => handleChange(Number(value), 'maxValue')}
            name='maxValue'
            placeholder='100'
          />
        </TextField>

        <div>{props.children}</div>
      </div>
    </Sheet>
  )
}

export default CriteriaTemplate
